<lib-elux-modal [open]="true" (onClose)="cancel.emit()">
  <div modal-header>
    <h1 class="heading-1 c-blue">{{ title }}</h1>
  </div>
  <div modal-body class="text d-flex flex-column">
    <div [innerHTML]="body"></div>
  </div>
  <div modal-footer>
    <div class="d-row">
      <lib-elux-button class="me-7" [content]="'Cancelar'" [type]="'text'" (click)="cancel.emit()" />
      <lib-elux-button [content]="'Excluir'" [type]="'basic'" (click)="confirm.emit()" />
    </div>
  </div>
</lib-elux-modal>
